/* Global utility functions.
 *
 * @file combined
 */

/* Scroll event listener with request animation frame throttling
 * use this instead of the native scroll listener
 * pass a function to this scroll listener
 */
export function scrollListener(myscrollFunction) {
    // Setup a timer
    let timeout;
    // Listen for resize events
    window.addEventListener(
        'scroll',
        function(event) {
            // If there's a timer, cancel it
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }
            // Setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(function() {
                // Run our scroll functions (Your code here)
                myscrollFunction(event);
            });
        },
        false
    );
}

/* Resize event listener with request animation frame throttling
 * use this instead of the native resize listener
 * pass a function to this resize listener
 */
export function resizeListener(myresizeFunction) {
    // Setup a timer
    let timeout;
    // Listen for resize events
    window.addEventListener(
        'resize',
        function(event) {
            // If there's a timer, cancel it
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }
            // Setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(function() {
                // Run our resize functions (Your code here)
                myresizeFunction(event);
            });
        },
        false
    );
}

/*
 *  IE 11 polyfill for ForEach loop.
 */
export function ie11forEachPolyfill() {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function(callback, thisArg) {
            thisArg = thisArg || window;
            for (let i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
}

/*
 *  Check if an element exisits
 */
export function elementExists(element) {
    return typeof element !== 'undefined' && element != null;
}

/*
 *  Slide Element Up
 */
const slideWatchers = {};
export function slideUp(target, duration = 500, callback) {
    clearTimeout(slideWatchers[target.id]);
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    slideWatchers[target.id] = setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');

        if (callback instanceof Function) {
            callback();
        }
    }, duration);
}

/*
 *  Slide Element Down
 */
export function slideDown(target, duration = 500, callback) {
    clearTimeout(slideWatchers[target.id]);
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    const height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    slideWatchers[target.id] = setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');

        if (callback instanceof Function) {
            callback();
        }
    }, duration);
}

/*
 *  Slide Toggle Element
 */
export function slideToggle(target, duration = 500, callback) {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration, callback);
    } else {
        return slideUp(target, duration, callback);
    }
}

// Load any scripts Asynchronous.
export function loadScriptAsync(uri) {
    return new Promise((resolve, reject) => {
        const tag = document.createElement('script');
        tag.src = uri;
        tag.async = true;
        tag.onload = () => {
            resolve();
        };
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
}

// To detect if the  borwser is IE or not.
export const isIE = () =>
    !!window.MSInputMethodContext && !!document.documentMode;

/**
 * This function is fot Accordion Toggle block.
 * It's moved here from block level in somecase we need to trigger from different block.
 * @param {array} toggleButtons
 */
export const toggleHandler = toggleButtons => {
    // Loop through buttons
    Array.from(toggleButtons).forEach(toggleButton => {
        // Add click event.
        toggleButton.addEventListener('click', function() {
            // Find parent's previous element
            const accordion = this.parentNode.previousElementSibling;
            const buttonText = this.children[1];

            const isOpen = accordion.classList.contains(
                'block-accordion-toggle__items--open'
            );

            if (isOpen) {
                this.classList.remove('a-toggle-button--open');
                accordion.classList.remove(
                    'block-accordion-toggle__items--open'
                );
                buttonText.innerText = this.dataset.open;
            } else {
                this.classList.add('a-toggle-button--open');
                accordion.classList.add('block-accordion-toggle__items--open');
                buttonText.innerText = this.dataset.close;
            }
        });
    });
};

/* =============================================================================
AJAX Pagination.
=============================================================================== */

export const initPagination = (ajax, target, postType) => {
    const pagination = document.querySelector(
        '.rs-page-cpt__ajax-pagination'
    );
    if (pagination) {
        pagination.addEventListener(
            'click',
            function(event) {
                const btnType = event.target.getAttribute('data-type');
                const options = {};
                if (btnType === 'next') {
                    options.post_page = parseInt(this.getAttribute('data-current-page')) + 1;
                    options[target.dataset.filterType] = target.dataset.filter;
                    fetchPosts(ajax, target, postType, options);
                } else if (btnType === 'prev') {
                    options.post_page = parseInt(this.getAttribute('data-current-page')) - 1;
                    options[target.dataset.filterType] = target.dataset.filter;
                    fetchPosts(ajax, target, postType, options);
                }
            },
            false
        );
    }
};

/**
 * To set current filter type and value to arrange pagination.
 *
 * @param {string} filterValue
 * @param {string} filterType
 */
function setCurrentFilter(target, filterValue, filterType) {
    target.dataset.filter = filterValue;
    target.dataset.filterType = filterType;
}

/**
 * This is a function to send a request by AJAX.
 *
 * @param {string} action ajax object contains action, nonce and ajaxUrl.
 * @param {string} target where content will be updated.
 * @param {string} postType post type.
 * @param {object} options params for filtering.
 * @param {function} adjustMobileFilter callback function for mobile filter.
 */

export const fetchPosts = (ajax, target, postType, options, adjustMobileFilter = null) => {
    const form = new FormData();
    form.append('action', ajax.action);
    form.append('post_type', postType);
    form.append('nextNonce', ajax.nextNonce);

    // Append additional option.
    if (options) {
        // eslint-disable-next-line no-unused-expressions
        options.s && adjustMobileFilter ? adjustMobileFilter(options.s, 'search') : null;
        // eslint-disable-next-line no-unused-expressions
        options.letter && adjustMobileFilter ? adjustMobileFilter(options.letter, 'letter') : null;
        // eslint-disable-next-line no-unused-expressions
        options.cpt_cat && adjustMobileFilter ? adjustMobileFilter(options.cpt_cat, 'cpt_cat') : null;

        for (const option in options) {
            if ({}.hasOwnProperty.call(options, option)) {
                form.append(option, options[option]);
                // @TODO: if multiple filter is needed in future, this function might be refactored.
                setCurrentFilter(target, options[option], option);
            }
        }
    }

    const params = new URLSearchParams(form);

    fetch(ajax.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params,
    })
        .then(response => response.text())
        .then(data => {
            target.querySelectorAll('*').forEach(n => n.remove());
            target.innerHTML = data;
        }).then(() => {
            initPagination(ajax, target, postType);
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error);
            setCurrentFilter(target, 'none', 'none');
        });
};

const selectFilters = document.querySelectorAll('.select-filter');

/**
 * If there is selected filter, reset it.
 *
 * @param {HTMLElement} current
 */
export const resetSelect = (current) => {
    selectFilters.forEach((filter) => {
        if (current.id !== filter.id) {
            filter.selectedIndex = filter.options.length - 1;
        }
    });
};

/**
 * Reset Alphabet
 *
 * @param {string} className
 */
export const resetAlphabet = (className) => {
    const alphabets = document.querySelectorAll(`.${className}`);
    if (alphabets) {
        alphabets.forEach((letter) => {
            containClass(letter, 'active') && letter.classList.remove('active');
        });
    }
};

/**
 * Truncate
 *
 * @param {String} str
 * @param {Number} n
 * @returns {String}
 */
export const truncate = (str, n) => {
    return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
};

/**
 * Mobile checker funvtion
 *
 * @returns {boolean}
 */
export const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

/**
 *
 * @param {HTMLElement} element
 * @returns boolean
 */
export const containClass = (element, className) => element.classList.contains(className);
